import { Stack } from '@mui/material';

import useStyles from './PDFTemplate.styles';
import type { PDFTemplateProps } from './PDFTemplate.types';
import PDFFooter from './PDFTemplateFooter';
import PDFHeader from './PDFTemplateHeader';

const PDFTemplate = ({
  children,
  variant = 'report',
  headerTitle = 'Test',
  headerClientLabel = 'Client Name',
  headerDateLabel = 'Date 2025',
  headerSectionLabel = 'EXECUTIVE SUMMARY',
  page_number = 0,
  dataTestId
}: PDFTemplateProps) => {
  const { classes, cx } = useStyles();

  return (
    <div
      data-testid={dataTestId}
      className={cx(
        classes.paper,
        variant === 'cover' ? null : classes.reportPage,
        (variant === 'cover' || variant === 'report') && classes.addPageBreak
      )}
    >
      {(variant === 'report' || variant === 'report-last') && (
        <PDFHeader
          title={headerTitle}
          clientLabel={headerClientLabel}
          dateLabel={headerDateLabel}
          sectionLabel={headerSectionLabel}
        />
      )}

      {children ? (
        <Stack
          spacing={3}
          className={
            variant === 'cover' ? classes.coverContent : classes.content
          }
        >
          {children}
        </Stack>
      ) : (
        <div />
      )}

      {(variant === 'report' || variant === 'report-last') && (
        <PDFFooter pageNumber={page_number} />
      )}
    </div>
  );
};

export default PDFTemplate;
